<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ ' navbar-dark': type === 'default' }"
  >
    <Support :open.sync="supportDialog" ref="supportDialog" />
    <modal :show.sync="helpModal" class="col-12" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Ajuda</h5>
      </template>
      <wizard :help="true">
        <div class="content">
          <wizard-tab title="Ano Safra" style="margin-left: 10px;">
            <h1>Ano Safra</h1>
            <p>
              O Ano Safra é um período central no sistema, responsável pela
              divisão de todos os períodos juntamente aos dados no sistema de
              cada ano safra.
            </p>
          </wizard-tab>
          <wizard-tab title="Papéis" style="margin-botton: 10px;">
            <h1>Papéis dentro do SGV</h1>
            <p>
              Cada papel possui suas permissões no sistema, definindo exatamente
              seu escopo de ações.
            </p>
          </wizard-tab>
          <wizard-tab title="Metas" style="margin-botton: 10px;">
            <h1>Metas</h1>
            <h3>Meta</h3>
            <p>
              Metas compreende um conjunto de metas relacionadas a quantia
              esperada de vendas no ano safra vigente.
            </p>
          </wizard-tab>
          <wizard-tab title="Pedidos" style="margin-botton: 10px;">
            <h1>Pedidos</h1>
            <h3>Pedido</h3>
            <p>
              Pedidos é uma área do sistema reservada às solicitações de pedidos
              de venda.
            </p>
          </wizard-tab>
          <wizard-tab title="Agenda" style="margin-botton: 10px;">
            <h1>Agenda</h1>
            <h3>Agenda</h3>
            <p>
              Agenda é um calendário que possui datas e horários de reuniões,
              encontros e eventos.
            </p>
          </wizard-tab>
          <wizard-tab title="Relatórios" style="margin-botton: 10px;">
            <h1>Relatórios</h1>
            <h3>Relatório</h3>
            <p>
              Relatórios é uma seção do sistema responsável por visualização de
              dados sensíveis filtrados por um determinado usuário.
            </p>
          </wizard-tab>
          <wizard-tab title="Curva ABC" style="margin-botton: 10px;">
            <h1>Curva ABC</h1>
            <h3>Curva ABC</h3>
            <p>
              Trata-se de uma metodologia de segmentação e agrupamento de itens
              segundo sua ordem de importância para a empresa
            </p>
          </wizard-tab>
        </div>
      </wizard>
    </modal>
    <!-- Navbar toggler -->
    <div class="mr-auto d-xl-none safe-area">
      <a
        @click="$sidebar.displaySidebar(!$sidebar.showSidebar)"
        class="nav-link pointer pr-0 mr-2"
        @click.prevent
        slot="title-container"
      >
        <div class="media align-items-center">
          <span class="avatar avatar-sm rounded-circle bg-white">
            <div
              class="sidenav-toggler"
              :class="{ active: $sidebar.showSidebar }"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </div>
          </span>
        </div>
      </a>
    </div>
    <!-- Search form -->
    <form
      class="navbar-search form-inline mr-sm-3"
      :class="{
        'navbar-search-light': type === 'default',
        'navbar-search-dark': type === 'light',
      }"
      id="navbar-search-main"
    >
      <div class="form-group mb-0">
        <SearchComponent />
      </div>
      <button
        type="button"
        class="close"
        data-action="search-close"
        data-target="#navbar-search-main"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </form>
    <!-- Navbar actions -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <notifications />
      <a
        @click="setTicket"
        class="nav-link pointer pr-0"
        @click.prevent
        slot="title-container"
        v-b-tooltip.hover.top
        title="Suporte"
      >
        <div class="media align-items-center">
          <span class="avatar avatar-sm rounded-circle">
            <avatar
              :size="36"
              src="/img/icons/headset.png"
              :username="currentUser.name || ' '"
            ></avatar>
          </span>
        </div>
      </a>

      <a
        @click="helpModal = true"
        class="nav-link pointer pr-0"
        @click.prevent
        slot="title-container"
      >
        <div class="media align-items-center">
          <span class="avatar avatar-sm rounded-circle">
            <avatar
              :size="36"
              src="/img/icons/help.png"
              :username="currentUser.name || ' '"
            />
          </span>
        </div>
      </a>

      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <avatar
                :size="36"
                :src="currentUser.avatar"
                :username="currentUser.name + ' '"
              />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">
                {{ currentUser.name }}
              </span>
            </div>
          </div>
        </a>

        <template>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Bem vindo!</h6>
          </div>
          <div>
            <a href="#!" @click="changePassword" class="dropdown-item">
              <router-link to="/updatepassword" tag="li">
                <i class="margem fa fa-key"></i>
                Alterar senha
              </router-link>
            </a>
          </div>

          <div class="dropdown-divider"></div>
          <a href="#!" @click="logout" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Sair</span>
          </a>
        </template>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import { Avatar } from "vue-avatar";
import Wizard from "@/components/Wizard/Wizard.vue";
import WizardTab from "@/components/Wizard/WizardTab.vue";
import Support from "../components/Support/Index.vue";
import { VBTooltip } from "bootstrap-vue/esm/directives/tooltip/tooltip";
import Notifications from "@/components/Navbar/Notifications.vue";
import SearchComponent from "../components/SearchComponent.vue";
import { mapState, mapActions } from 'vuex';


export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
    Avatar,
    Wizard,
    WizardTab,
    Support,
    Notifications,
    SearchComponent,
  },

  directives: {
    BTooltip: VBTooltip,
  },

  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapState({
      notificationAssociableId: state => state.notificationAssociableId,
      notificationAssociableType: state => state.notificationAssociableType,
    }),
  },
  data() {
    return {
      currentUser: this.$currentUser(),
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      supportDialog: false,
      helpModal: false,
      tabPosition: "left",
      notificationNumber: 0,
      ticket: {
        requester: {
          id: this.$root.$data.currentUser.id,
          nome: this.$root.$data.currentUser.name,
          email: this.$root.$data.currentUser.email,
          tel: this.$root.$data.currentUser.telefone,
          sala:
            this.$root.$data.currentUser && this.$root.$data.currentUser.role
              ? this.$root.$data.currentUser.role.name
              : "",
          indentificador: this.$root.$data.currentUser.id,
          lotacao: this.$root.$data.currentUser.cpf,
        },
        faseContratacao: "faseContratacao",
        secao: "Sessão",
        datadeabertura: new Date(),
        lotacaodemandante: "lotação",
        ocupacaodemandante: "ocupação",
        ia: null,
        ir: null,
        it: null,
        acquisition_plan: {
          phase: this.$route.name,
          subphase: this.$route.path,
          requesters: null,
        },
        attendance: {
          step: 0,
          paused: 0,
        },
        id: 2,
        pauseCounter: 1,
      },
      notificationSupport: []
    };
  },
  methods: {
    ...mapActions(['resetNotificationClassAction']),
    setTicket() {
      this.ticket.requester.id = this.$root.$data.currentUser.id;
      this.ticket.requester.nome = this.$root.$data.currentUser.name;
      this.ticket.requester.email = this.$root.$data.currentUser.email;
      this.ticket.requester.tel = this.$root.$data.currentUser.telefone;
      this.ticket.requester.sala = this.$root.$data.currentUser.role.name;
      this.ticket.requester.indentificador = this.$root.$data.currentUser.id;
      this.ticket.requester.lotacao = this.$root.$data.currentUser.cpf;
      this.ticket.acquisition_plan.phase = this.$route.name;
      this.ticket.acquisition_plan.subphase = this.$route.path;
      this.supportDialog = true;
    },
    sendTicket() {
      this.$http.secured
        .post("https://suporte.sgv.dtr40.com.br/api/services", this.ticket)
        .then((response) => {
          this.$toasted.global.defaultSuccess({
            msg: "Suporte solicitado, em breve entraremos em contato!",
          });
          this.supportDialog = false;
          this.ticket.acquisition_plan.requesters = null;
        })
        .catch((error) => {
          this.$refs.formValidator.setErrors(error.response.data);
        });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    async logout() {
      this.$unauthenticateUser()
    },
    changePassword() {},
    async getSupport() {
      try {
        const response = await this.$http.secured.get("api/v1/support_ticket_show", {
          params: {
            id: this.notificationAssociableId
          }
        });
        this.notificationSupport = response.data;
      } catch (error) {
        console.error("Erro ao buscar suporte:", error);
      }
    },
  },
  watch: {
    notificationAssociableType(newValue) {
      if (!newValue || newValue != 'Api::V1::SupportBridgeController') return;
      this.getSupport();
      this.supportDialog = true;
      this.$refs.supportDialog.openDetails(this.notificationSupport);
      this.resetNotificationClassAction();
    }
  }
};
</script>
<style>
.safe-area{
  margin-top: constant(safe-area-inset-top);
  margin-top: calc(15px  + env(safe-area-inset-top));
  margin-bottom: calc(15px + env(safe-area-inset-top));
}

.margem {
  margin-right: 12px;
}
</style>
